import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import {
  AlertController,
  ModalController,
  ToastController,
  PopoverController,
  IonContent,
  Platform
} from '@ionic/angular';
import { DatePipe, formatDate } from '@angular/common';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { VideoCallService } from 'src/providers/videocall';
import { CommonService } from 'src/providers/common';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { DoclistmodPage } from './doclistmod/doclistmod.page';
import { ReviewPage } from '../review/review.page';
import { ViewmodelPage } from '../viewmodel/viewmodel.page'
declare var google;
import { Geolocation } from '@ionic-native/geolocation/ngx';
import {
  LaunchNavigator,
  LaunchNavigatorOptions,
} from '@ionic-native/launch-navigator/ngx';
import { AddCall } from 'src/providers/addvCall';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import * as AWS from 'aws-sdk';
import * as moment from 'moment';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { SuccessPage } from 'src/app/success/success.page';
@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.page.html',
  styleUrls: ['./appointments.page.scss'],
})
export class AppointmentsPage implements OnInit {
  @ViewChild('mapid', { static: false }) mapElement: ElementRef;
  @ViewChild(IonContent, { static: false }) ioncontent: IonContent;
  map: any;
  changecount: any = 0;
  latitude: number;
  longitude: number;
  directionsService = new google.maps.DirectionsService();
  directionsDisplay = new google.maps.DirectionsRenderer();
  currentLocation: any = {
    lat: 0,
    lng: 0,
  };
  Latlan: any;
  selectedSegment: string = 'appion';
  previousSegment: string = 'appion';
  private common = CommonService;
  DocAppointment = [];
  DocAppointmentHis = [];
  Docbookdetails = [];

  today: any;
  bookdate: any;
  time: any;

  rate: any;
  presentView: string;

  showSlides1: any = null;
  advFilter1: boolean;
  reviewPopUp: boolean;
  showRefundPopUp: boolean;

  appointment: boolean;
  history: boolean;
  prescrpition: boolean;

  currentDate: any;
  currentTime: any;
  doctorId: any;
  bookingId: any;
  FilterPatList = [];
  FilterDocList = [];
  particularPatient: any;
  particularDoctor: any;
  fromDate5: any;
  notifications: boolean = false;
  bookings: boolean = false;
  referrals: boolean = false;
  history1: boolean = false;
  trainer: boolean = false;

  toDate5: any;
  totalAmountRefund: any;
  PrescriptionDetails = [];
  patientName: any;
  doctorName: any;
  prescriptDate: any;
  cancelledPageDetl: boolean;
  PartCancelledDet: any;
  canclFTime: any;
  canclTTime: any;
  pageNo: number = 1;
  medicineDetails: any;
  EmptyData: any;
  getStrRating: any;
  getRemark: any;
  getDocId: any;
  getDocName: any;
  reShedule: boolean = false;
  getDocImg: any;
  bookingAmnt: any;
  cardClicked = false;
  filterActive: boolean = false;
  profileImage: string;
  queueList: any = [];
  minDate: string;
  maxDate: string;
  cliLoc: any;
  cliLoc1: any;
  queuePos: any;
  QuePos: any;
  AdvFillVal: any;
  scrollEvent: any;
  status: any;
  spclDocName: any;
  spclty: any;
  nextCount: number;
  appListReq: any;
  appHisListReq: any;
  queueReq: any;
  presDetReq: any;
  patListReq: any;
  docListReq: any;
  refreshEvent: any;
  queueCount: any;
  display: any;
  showTypeofBooking: any = '';
  moduleType: any = '';
  public timerInterval: any;
  QueuePosImg: any;
  QuePosIndex: any;
  QuePosImg: any;
  zIndexValue: any;
  formattedTimeString: any;
  CurrentDateValue: any;
  endtime: string;
  selectedCardindex: number;
  selectedCardSegment: number;
  moduleimagesheader: string;
  routeId: any;
  routeTypeId: any;
  constructor(
    public router: Router,
    public activeRoute: ActivatedRoute,
    private services: ServicesProvider,
    public alertCtrl: AlertController,
    private datePipe: DatePipe,
    public toastController: ToastController,
    public modalCtrl: ModalController,
    public videocall: VideoCallService,
    private androidPermissions: AndroidPermissions,
    public popoverCtrl: PopoverController,
    public geolocation: Geolocation,
    public launchNavigator: LaunchNavigator,
    public platform: Platform,
    public addCall: AddCall
  ) { this.checkMediaPermissions(); }

  ngOnInit() {
    this.activeRoute.queryParams.subscribe(params => {
      const id = params['id'];
      const typeid = params['typeId'];
      this.routeId = id;
      this.routeTypeId = typeid;
      console.log(id)
    });
    localStorage.setItem('bookindId', this.routeId);
    localStorage.setItem('VendorType', this.routeTypeId);
    console.log("selectedCardindex", this.selectedCardindex, this.addCall.title327)
  }

  //----------------------SOME LOGICAL FUNCTION-------------------//

  doRefresh(event, value) {
    this.refreshEvent = event;
    this.showSlides1 = null;
    this.pageNo = 1;
    this.filterActive = false;
    this.EmptyData = null;
    this.EmptyData = 1;
    if (value == 'listApnMnt') {
      this.patientBookedAppointmentList();
    } else if (value == 'listApnMntHis') {
      this.patientBookedAppointmentHistoryList();
    }
  }

  refFunc() {
    if (this.refreshEvent) {
      this.refreshEvent.target.complete();
    }
  }
  infyFunc() {
    if (this.scrollEvent) {
      this.scrollEvent.target.complete();
    }
  }

  loadData(event, page) {
    this.pageNo += 1;
    this.scrollEvent = event;

    if (this.nextCount == 0) {
      event.target.disabled = true;
    } else {
      if (page == 'listApnMnt') {
        if (this.filterActive == false) {
          this.patientBookedAppointmentList();
          console.log('filter Not Active');
        } else {
          console.log('filter Active');
          this.AdvFillVal = '';
          this.patientAppointmentAdvancedFilter();
        }
      } else if (page == 'listApnMntHis') {
        if (this.filterActive == false) {
          console.log('filter Not Active');
          this.patientBookedAppointmentHistoryList();
        } else {
          console.log('filter Active');
          this.AdvFillVal = 'history';
          this.patientAppointmentAdvancedFilter();
        }
      }
    }
  }
  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async presentModal(bookingId, bookingAmnt) {
    this.bookingId = bookingId;
    this.bookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt,
      },
    });
    modal.onDidDismiss().then((data) => {
      const res = data;
      console.log(res);
      if (res.data != null) {
        console.log(res.data);
        console.log('booking id=>', res.data.bookingId);
        console.log('booking amnt=>', res.data.bookingAmnt);
        this.cancelDoctorAppointment();
        this.pageNo = 1;
      }
    });
    return await modal.present();
  }

  async showaddress(address, myEvent) {
    console.log('checkout address');

    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: 'doctorBKFC',
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss();
    return await popover.present();
  }
  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return '';
    }

    let Value;
    switch (callFor) {
      case 'Time':
        if (dateTime.indexOf('T') > -1) {
          Value = dateTime.split('T')[1];
        } else if (dateTime.indexOf(' ') > -1) {
          Value = dateTime.split(' ')[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(':');
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = H < 12 || H === 24 ? 'am' : 'pm';
        let timeString = h + String(Value).substr(hourEnd, 3) + ' ' + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        return timeString;
      case 'Date':
        return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy');
      case 'DateTime':
        return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy h:mm a');
      case 'Date1':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd-MMM-yy');
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          let day = String(dateCall.getDate()).padStart(2, '0'); // Add leading zero if necessary
          let arDate =
            day +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }
  async dietexplainervideo(vendor_id, menu_id) {

    const dietvideo = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'diethowtobookvideo',
      backdropDismiss: false,
      componentProps: {
        trainerReschedule: 'rescheduletrainerexplainervideo',
        vendorid: vendor_id,
        menuid: menu_id,
      },
    });
    await dietvideo.present();
  }
  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  navigateToLab() {
    this.router.navigate(['/tabs/lab']);
  }

  openPrescription() {
    this.router.navigate(['/tabs/prescription', { frmPage: 'histry' }]);

    localStorage.setItem('NopayGoBack', 'newEnter');
  }
  openRoomBooking() {
    this.router.navigate(['/tabs/booking-room']);

    localStorage.setItem('NopayGoBack', 'newEnter');
  }

  goToNursing() {
    this.router.navigate(['/tabs/nursing']);
    localStorage.setItem('NopayGoBack', 'newEnter');
  }

  godietMealPage() {
    this.router.navigate(['/tabs/dietmeal']);
    localStorage.setItem('NopayGoBack', 'newEnter');
  }

  goToTrainer() {
    this.router.navigate(['/tabs/trainer']);

    localStorage.setItem('NopayGoBack', 'newEnter');
  }

  goPhysitherapy() {
    this.router.navigate(['/tabs/newphysiotherapy']);

    localStorage.setItem('NopayGoBack', 'newEnter');
  }

  goTrainingCenter() {
    this.router.navigate(['/tabs/trainingCenter']);

    localStorage.setItem('NopayGoBack', 'newEnter');
  }

  notification() {
    this.previousSegment = this.selectedSegment;
    this.selectedSegment = 'notify';
    this.referrals = false;
    this.history = false;
    this.router.navigate(['/tabs/commonNotification']);
  }

  ionViewWillEnter() {
    this.getbookingdetails();
    let modulename = this.activeRoute.snapshot.paramMap.get('moduleType');
    let activeMenuId = localStorage.getItem("notificationActiveMenuId");
    let activeref = localStorage.getItem("frmPage");
    this.moduleType = "Doc";
    this.selectedCardindex = 1;
    const routeGetVariable = this.activeRoute.snapshot.paramMap.get('frmPage');
    if (routeGetVariable == "Physio") {
      this.moduleType = "Physio";
      activeMenuId = "12"
    } else {
      this.moduleType = "Doc";
    }
    if (modulename == 'diet') {
      this.moduleType = "diet";
      activeMenuId = '8';
    }
    else {
      localStorage.setItem('bookview', "");
      localStorage.setItem('bookviewindex', "");
      localStorage.setItem('bookviewdays', "");
    }
    if (activeMenuId == '1') {
      this.moduleType = "Doc";
      this.isShowrepeatPage = false;
      this.selectedCardindex = 1;
    }
    if (activeMenuId == '2') {
      this.moduleType = "Lab";
      this.selectedCardindex = 2;
    }
    if (activeMenuId == '12') {
      this.moduleType = "Physio";
      this.isShowrepeatPage = false;
      this.selectedCardindex = 12;
      this.selectedCardindex = 8;
    }
    if (activeMenuId == '8') {
      this.moduleType = "diet";
      this.isShowrepeatPage = false;
      this.selectedCardindex = 6;
    }
    if (activeMenuId == '6') {
      this.moduleType = "trainer";
      this.isShowrepeatPage = false;
      this.selectedCardindex = 7;
    }
    if (activeMenuId == '5') {
      this.moduleType = "nurse";
      this.isShowrepeatPage = false;
      this.selectedCardindex = 5;
    }
    if (activeMenuId == '7') {
      this.moduleType = "sports";
      this.isShowrepeatPage = false;
      this.selectedCardindex = 9;
    }
    if (activeMenuId == '10') {
      this.moduleType = "bookaroom";
      this.isShowrepeatPage = false;
      this.selectedCardindex = 4;
    }

    this.activeRoute.snapshot.paramMap.get('frmPage');
    this.selectedCardSegment = 1;
    this.common.videoSound = false;
    this.common.setDoctorDetails(false);
    console.log(this.common.videoSound, 'VideoSound');
    console.log(this.activeRoute.snapshot.paramMap.get('frmPage'));
    console.log(this.activeRoute.snapshot.paramMap.get('moduletype'));

    this.moduleimagesheader = 'doctorbooking';
    this.changecount = 0;
    this.bookings = true;
    if (this.moduleType == 'Doc' || this.moduleType == '') {
      this.moduleType = 'Doc';
      this.changeheader = 'dochead';
    } else if (this.moduleType == 'Physio') {
      this.moduleType = 'Physio';
      if (routeGetVariable == 'PhysioReferral') {
        this.changeheader = 'Physio';
      }
    }
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.status = null;
    this.PatName = '';
    this.showSlides1 = null;
    localStorage.setItem('key', 'value');
    this.showTypeofBooking = '';
    this.presentView = 'trainer';
    this.showTypeofBooking = '';
    this.appointment = true;
    this.history = false;
    this.prescrpition = false;
    this.filterActive = false;
    this.trainer = true;
    //Events......
    this.advFilter1 = false;
    this.reviewPopUp = false;
    this.showRefundPopUp = false;

    this.pageNo = 1;
    this.setQueue();
    this.EmptyData = null;
    // this.patientBookedAppointmentList();
    // this.advanceFilterPatientList();
    // this.advanceFilterDoctorList();
    // this.backToAppointment();
    console.log('c1');


  }


  async selSetImg() {
    let _obj = this;
    const alert = await this.modalCtrl.create({
      component: DoclistmodPage,
      cssClass: 'docs-list-mod',
      componentProps: {
        FilterDocList: _obj.FilterDocList,
        docID: this.particularDoctor,
        docName: this.spclDocName,
        spclty: this.spclty,
      },
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      console.log('Data From Modal -> ', data);
      if (data.data.From == 2) {
        this.particularDoctor = data.data.docID;
        this.spclDocName = 'Dr.' + data.data.docName;
        this.spclty = data.data.spclty;
      }
    });

  }

  ionViewWillLeave() {
    clearInterval(this.time);
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.moduleType = "";
  }

  setQueue() {
    this.queueList = [];
    let item = 'assets/img/persnIcon1.png';
    for (let i = 1; i <= 4; i++) {
      this.queueList.push(item);
    }
  }

  backToHome() {
    debugger;
    this.selectedSegment = this.previousSegment;
    clearInterval(this.time);
    this.appointment = false;
    this.history = false;
    this.prescrpition = false;

    this.advFilter1 = false;
    this.reviewPopUp = false;
    this.showRefundPopUp = false;
    this.router.navigate(['/tabs/home']);
  }

  openReschedule(
    docId,
    clinicId,
    serviceTypeId,
    fromTime,
    toTime,
    patientName,
    bookingId,
    book_date,
    patientId,
    appointmentTypeId,
    dName,
    servname,
    specialty,
    paymenttype,
    alreadybooked,
    Servicecost,
    specid
  ) {
    console.log(paymenttype);
    window.localStorage['rescheduleServiceTypeId'] = serviceTypeId;
    let fTime = fromTime.split(':');
    let fTime1 = fTime[0];
    let fTime2 = fTime[1];
    let fromTime1 = fTime1 + ':' + fTime2;
    let tTime = toTime.split(':');
    let tTime1 = tTime[0];
    let tTime2 = tTime[1];
    let toTime1 = tTime1 + ':' + tTime2;
    let itWasSunny = false;

    localStorage.setItem('fromPage', 'reschedule');
    localStorage.setItem('reschedulePatientId', patientId);
    window.localStorage['docName'] = dName;
    this.router.navigate([
      '/tabs/doc-appointment',
      {
        doctorId: docId,
        clinicId: clinicId,
        serviceTypeId: serviceTypeId,
        reschFTym: fromTime1,
        reschTTym: toTime1,
        patientName: patientName,
        bookingId: bookingId,
        searchDate: book_date.split(' ')[0] || book_date.split('T')[0],
        reschDate: book_date.split(' ')[0] || book_date.split('T')[0],
        reschlPatientId: patientId,
        appointmentTypeId: appointmentTypeId,
        mode: itWasSunny,
        ServiceName: true,
        specialityName: specialty,
        paymenttype: paymenttype,
        book_amount: alreadybooked,
        APServiceCost: Servicecost,
        splid: specid,
      },
    ]);
  }

  openAppointment1() {
    this.router.navigate(['/tabs/speciality']);
  }

  openAppointment2() {
    this.router.navigate(['/tabs/speciality']);
  }

  option = {
    slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: -210,
  };

  showSlide1(index, doctor_id, bookingId, clinic_id, bookDate, patient_id) {
    const nowDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-us')
    if (bookDate == nowDate) {
      this.setQueue();
      this.QuePos = '0th';
      this.queuePos = 0;
      this.doctorId = doctor_id;
      this.bookingId = bookingId;
      this.memberQueueDetailsForParticularBooking(
        clinic_id,
        index,
        patient_id,
        doctor_id
      );
    } else {
      this.presentToast('Queue will be available on appointment date');
    }
  }
  goBackToPreviousSegment() {
    this.selectedSegment = this.previousSegment;
  }

  openHistory() {
    debugger;
    this.showSlides1 = null;
    this.selectedCardSegment = 3;
    console.log(this.presentView);
    this.trainer = false;
    if (this.moduleType != 'Doc') {
      this.checkout('booking hitory');
    } else if (this.moduleType == 'sports') {
      this.showTypeofBooking = 'booking hitory';
    } else if (this.moduleType == 'bookaroom') {
      this.showTypeofBooking = 'booking hitory';
    } else if (this.moduleType == 'trainer') {
      this.showTypeofBooking = 'booking hitory';
    }
    this.previousSegment = this.selectedSegment;
    this.selectedSegment = 'his';
    this.referrals = false;
    this.bookings = false;
    this.history = true;
    clearInterval(this.time);
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.status = null;
    this.pageNo = 1;
    this.EmptyData = null;
    this.filterActive = false;
    this.patientBookedAppointmentHistoryList();
    this.presentView = 'history';
    this.prescrpition = false;
    this.appointment = false;


    this.showSlides1 = null;
  }
  backToAppointment() {
    debugger;
    if (this.moduleType == 'pharmacy') {
      this.backToHome();
    }
    this.selectedCardSegment = 1;
    this.trainer = true;
    this.isShowrepeatPage = false;

    console.log(this.presentView);

    if (this.moduleType == 'Physio') {
      this.checkout('booking');
    } else if (this.moduleType != 'Doc') {
      this.checkout('booking');
    }
    this.previousSegment = this.selectedSegment;
    this.selectedSegment = 'appion';
    this.referrals = false;
    this.history = false;
    this.bookings = true;
    this.status = null;
    this.pageNo = 1;
    this.EmptyData = null;
    this.filterActive = false;
    this.patientBookedAppointmentList();
    this.presentView = 'appointment';
    this.appointment = true;
    this.prescrpition = false;
    this.moduleimagesheader = 'doctorbooking';
  }

  openPrescrpition(bookingId) {
    this.bookingId = bookingId;
    this.particularBookingPrescriptionDetails(bookingId);
    this.presentView = 'prescrpition';
    this.appointment = false;
    this.history = false;
    this.prescrpition = true;
  }
  backToHistory() {
    this.pageNo = 1;
    this.filterActive = false;
    this.presentView = 'history';
    this.moduleimagesheader = 'doctorbooking';
    this.appointment = false;
    this.history = true;
    this.prescrpition = false;
  }

  advanceFilter(val, from) {
    this.spclDocName = '';
    this.spclty = '';
    this.status = null;
    this.AdvFillVal = from;
    if (val == 1) {
      this.minDate = new Date(Date.now()).toISOString().split('T')[0];
      this.maxDate = '2100';
    } else if (val == 2) {
      this.minDate = '1970';
      this.maxDate = new Date(Date.now()).toISOString().split('T')[0];
    }
    this.PatName = '';
    this.particularPatient = '';
    this.particularDoctor = '';
    this.fromDate5 = null;
    this.toDate5 = null;
    this.advFilter1 = !this.advFilter1;
  }

  openCancelled(cancelStatus, index) {
    if (cancelStatus == 1) {
      this.PartCancelledDet = this.DocAppointmentHis[index];
      this.presentView = 'cancelledPageDetl';
      this.cancelledPageDetl = true;
      this.history = false;

      this.canclFTime = this.getFormattedDateTime(
        this.PartCancelledDet.from_time,
        'Time'
      );
      this.canclTTime = this.getFormattedDateTime(
        this.PartCancelledDet.to_time,
        'Time'
      );
    }
  }
  backToFromCancel() {
    this.presentView = 'history';
    this.cancelledPageDetl = false;
  }

  Reviews(docId, docImg, docName) {
    this.getDocId = docId;
    this.getDocImg = docImg;
    this.getDocName = docName;
    this.reviewPopUp = !this.reviewPopUp;
  }
  searchIt() {
    this.pageNo = 1;
    this.filterActive = true;

    if (!this.particularPatient) {
      this.presentToast('Please select patient name.');
    } else if (!this.particularDoctor) {
      this.presentToast('Please select doctor name.');
    } else if (!this.fromDate5) {
      this.presentToast('Please select from date.');
    } else if (!this.toDate5) {
      this.presentToast('Please select to date.');
    } else {
      this.DocAppointment = [];
      this.DocAppointmentHis = [];
      let ft = new Date(this.fromDate5);
      this.fromDate5 =
        ft.getFullYear() +
        '-' +
        ('0' + (ft.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + ft.getDate()).slice(-2);
      let tt = new Date(this.toDate5);
      this.toDate5 =
        tt.getFullYear() +
        '-' +
        ('0' + (tt.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + tt.getDate()).slice(-2);
      this.EmptyData = null;
      this.patientAppointmentAdvancedFilter();
    }
  }

  //API Integration Events...............
  PatName: any;
  listOfPatients() {
    console.log('=======', this.particularPatient);

    for (let item of this.FilterPatList) {
      if (item.patient_id == this.particularPatient) {
        this.PatName = item.patientName;
      }
    }
  }
  listOfDoctors() {
    this.particularDoctor;
  }

  refundOption(bookingId, index) {
    this.showRefundPopUp = !this.showRefundPopUp;
    this.bookingId = bookingId;
    console.log('bookingId = ', this.bookingId);
    if (this.showRefundPopUp == true) {
      this.totalAmountRefund = this.DocAppointment[index].book_amount;
    } else {
      this.totalAmountRefund = 0;
    }
  }
  refundAmount() {
    console.log('bookingId = ', this.bookingId);
    this.showRefundPopUp = false;
    this.cancelDoctorAppointment();
    this.pageNo = 1;
  }
  processRefund() {
    console.log('bookingId = ', this.bookingId);
    this.showRefundPopUp = false;
    this.cancelDoctorAppointment();
    this.pageNo = 1;
    this.DocAppointment = [];
  }

  //API integration..................
  clinicname: any;
  P_Name: any;
  patientBookedAppointmentList() {
    const currentTimeUTC = new Date().toUTCString();
    console.log('Current UTC time:', currentTimeUTC);
    let minuUTC = currentTimeUTC.slice(17, 25);
    console.log('Current UTC time:', minuUTC);
    this.CurrentDateValue = new Date().toISOString().slice(0, 10);
    console.log('Current Date:', this.CurrentDateValue);
    let now = new Date();
    let hours = now.getHours().toString().padStart(2, '0');
    let minutes = now.getMinutes().toString().padStart(2, '0');
    let seconds = now.getSeconds().toString().padStart(2, '0');

    this.formattedTimeString = hours + ':' + minutes + ':' + seconds;
    console.log('time =', this.formattedTimeString);
    try {
      if (this.appListReq) {
        this.appListReq.unsubscribe();
      }
      let getDate = new Date();
      this.currentDate =
        getDate.getFullYear() +
        '-' +
        ('0' + (getDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + getDate.getDate()).slice(-2);

      let requestdata = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        currentDate: this.currentDate,
        current_time: new Date().toTimeString().split(' ')[0],
        pageno: this.pageNo,
        limit: 10,
      });
      this.appListReq = this.services
        .postRequest('patientBookedAppointmentList', requestdata)
        .subscribe(
          (response) => {
            console.log('Booked List => ', response);

            this.EmptyData = response.status;
            this.status = response.status;
            response.status == 1
              ? (this.nextCount = response.data[0].nextCount)
              : (this.nextCount = 0);
            if (this.scrollEvent) {
              this.scrollEvent.target.disabled =
                this.nextCount == 0 ? true : false;
            }
            if (this.pageNo == 1) {
              this.DocAppointment = [];
            }
            if (response.data.length > 0) {
              for (let item of response.data[0].details) {
                item['timer'] = '';
                console.log(
                  item.patientName,
                  '======================================================================>'
                );
                let slotdate = item.book_date;
                let slottime = item.to_time;
                let givenTime = moment(
                  String(slotdate) + 'T' + String(slottime)
                );
                this.DocAppointment.push(item);
                this.Docbookdetails.push(item);
                this.checkingtimevalidation();
              }
              console.log(this.DocAppointment, 'this.DocAppointment');
            }
            this.refFunc();
            this.infyFunc();
          },
          (err) => {
            console.log(err);
            this.refFunc();
            this.infyFunc();
          }
        );
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  async patientBookedAppointmentHistoryList() {
    try {
      if (this.appHisListReq) {
        this.appHisListReq.unsubscribe();
      }
      let getDate = new Date();
      this.currentDate =
        getDate.getFullYear() +
        '-' +
        ('0' + (getDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + getDate.getDate()).slice(-2);
      let curTime = new Date().toString().split(' ')[4];
      let curDateTime = this.currentDate + ' ' + curTime;
      let requestdata = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        currentDate: curDateTime,
        pageno: this.pageNo,
        limit: 10,
      });
      this.appHisListReq = this.services
        .postRequest('patientBookedAppointmentHistoryList', requestdata)
        .subscribe(
          (response) => {
            console.log('Booked History => ', response);

            this.EmptyData = response.status;
            this.status = response.status;

            response.status == 1
              ? (this.nextCount = response.data[0].nextCount)
              : (this.nextCount = 0);
            if (this.scrollEvent) {
              this.scrollEvent.target.disabled =
                this.nextCount == 0 ? true : false;
            }
            if (this.pageNo == 1) {
              this.DocAppointmentHis = [];
            }
            if (response.data.length > 0) {
              for (let item of response.data[0].details) {
                this.DocAppointmentHis.push(item);
              }
            }
            this.refFunc();
            this.infyFunc();
          },
          (err) => {
            this.refFunc();
            this.infyFunc();
          }
        );
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }
  ngAfterViewInit() {
    console.log("this.pageNo")
  }

  memberQueueDetailsForParticularBooking(clinic_id, idx, patient_id, doctor_id) {
    this.queueCount = 0;

    if (this.queueReq) {
      this.queueReq.unsubscribe();
    }
    let getDate = new Date();
    this.currentDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-us')
    this.currentTime = new Date().toTimeString().split(' ')[0];
    let requestdata = JSON.stringify({
      clinic_id: clinic_id,
      doctor_id: this.doctorId,
      book_date: this.currentDate,
    });
    const serviceMapping = {
      1: () => this.services.postRequestDoc('getQueueList', requestdata),
      12: () => this.services.postRequestPhysioDoc('getQueueList', requestdata),
      // Add more mappings as needed
    };

    if (serviceMapping[this.routeTypeId]) {
      this.queueReq = serviceMapping[this.routeTypeId]().subscribe((res) => {
        // Handle the response here
        if (this.showSlides1 == idx) {
          this.showSlides1 = null;
        } else {
          /*curDate === bkDate*/
          if (1 == 1) {
            this.showSlides1 = idx;
          } else {
            this.presentToast('Queue will be available on appointment date');
            this.showSlides1 = null;
          }
        }
        this.zIndexValue = 8;
        if (res.status != 0) {
          const filters = { arrived_status: '1', check_in_status: 0 };
          const filteredArray = res.data[0].result.filter((item) => {
            // Check if all key-value pairs in the filters object match
            return Object.entries(filters).every(
              ([key, value]) => item[key] === value
            );
          });
          filteredArray.forEach((item, i) => {
            if (item.patient_id == patient_id && item.doctor_id == doctor_id) {
              this.QuePos = i + 1;
              this.QuePosImg = i + 1;
              this.QuePosIndex = item.queueno - 1;
              this.QueuePosImg = item.file_name;
              for (let i = 0; i < 7; i++) {
                if (i == Number(this.QuePos) - 1) {
                  this.queueList[i] =
                    res.data[0].result[this.QuePosIndex].file_name;
                  if (this.QuePos == 1) {
                    this.QuePos = this.QuePos + 'st';
                  } else if (this.QuePos == 2) {
                    this.QuePos = this.QuePos + 'nd';
                  } else if (this.QuePos == 3) {
                    this.QuePos = this.QuePos + 'rd';
                  } else if (this.QuePos > 3) {
                    this.QuePos = this.QuePos + 'th';
                  }
                } else if (i == 7 && Number(this.QuePos) - 1 > 7) {
                  console.log('123456');
                  this.queueList[4] =
                    res.data[0].result[this.QuePosIndex].file_name;
                  this.QuePos = this.QuePos + 'th';
                }
              }
            }
          });
        }
      });
    } else {
      console.error('Invalid routeTypeId:', this.routeTypeId);
    }


    // this.queueReq = this.services
    //   .postRequestDoc('getQueueList', requestdata)
    //   .subscribe((res) => {

    //   });
  }

  particularBookingPrescriptionDetails(id) {
    if (this.presDetReq) {
      this.presDetReq.unsubscribe();
    }
    this.PrescriptionDetails = [];
    this.EmptyData = null;
    let requestdata = JSON.stringify({
      bookingId: id,
    });
    this.presDetReq = this.services
      .postRequest('particularBookingPrescriptionDetails', requestdata)
      .subscribe((response) => {
        console.log('Prescription Details => ', response);
        this.EmptyData = response.status;
        console.log('EmptyData=>', this.EmptyData);
        if (response.data.length > 0) {
          this.PrescriptionDetails = response.data;
          this.patientName = response.data[0].patientName;
          this.doctorName = response.data[0].doctorName;
          this.prescriptDate = response.data[0].prescript_date.split(' ')[0];
          this.medicineDetails = JSON.parse(response.data[0].medicineDetails);
          console.log('Medicition=>', this.medicineDetails);
        } else {
          this.PrescriptionDetails = [];
        }
      });
  }

  advanceFilterPatientList() {
    if (this.patListReq) {
      this.patListReq.unsubscribe();
    }
    let requestdata = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
    });
    this.patListReq = this.services
      .postRequest('advanceFilterPatientList', requestdata)
      .subscribe((response) => {
        console.log('Patient List => ', response);
        this.FilterPatList = response.data;
      });
  }

  advanceFilterDoctorList() {
    if (this.docListReq) {
      this.docListReq.unsubscribe();
    }
    let requestdata = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
    });
    this.docListReq = this.services
      .postRequest('advanceFilterDoctorList', requestdata)
      .subscribe((response) => {
        console.log('Doctors List => ', response);
        this.FilterDocList = response.data;
      });
  }

  patientAppointmentAdvancedFilter() {
    this.advFilter1 = false;
    let time = new Date().toTimeString().split(' ')[0];
    let requestdata = JSON.stringify({
      pageno: this.pageNo,
      limit: 10,
      patientId: this.particularPatient,
      fromDate: this.fromDate5,
      toDate: this.toDate5,
      doctorId: this.particularDoctor,
      currentTime: time,
      type: this.AdvFillVal,
    });
    this.services
      .postRequest('patientAppointmentAdvancedFilter', requestdata)
      .subscribe((response) => {
        console.log('Doctors List =>', response);

        this.EmptyData = response.status;
        this.status = response.status;

        response.status == 1
          ? (this.nextCount = response.data[0].nextCount)
          : (this.nextCount = 0);
        if (this.scrollEvent) {
          this.scrollEvent.target.disabled = this.nextCount == 0 ? true : false;
          this.scrollEvent.target.complete();
        }

        if (this.presentView == 'appointment') {
          if (response.data.length > 0) {
            for (let item of response.data[0].details) {
              this.DocAppointment.push(item);
            }
          }
        } else if (this.presentView == 'history') {
          if (response.data.length > 0) {
            for (let item of response.data[0].details) {
              this.DocAppointmentHis.push(item);
            }
          }
        }

        if (this.pageNo == 1) {
          if (this.presentView == 'appointment') {
            if (response.status == 1) {
              this.DocAppointment = response.data[0].details;
              for (let item of this.DocAppointment) {
                this.cliLoc = JSON.parse(item.clinicDetails)[0].vendor_location;
              }
            } else {
              this.DocAppointment = [];
            }
          } else if (this.presentView == 'history') {
            if (response.status == 1) {
              this.DocAppointmentHis = response.data[0].details;
              for (let item of this.DocAppointmentHis) {
                this.cliLoc1 = JSON.parse(
                  item.clinicDetails
                )[0].vendor_location;
              }
            } else {
              this.DocAppointmentHis = [];
            }
          }
        }
        if (this.refreshEvent) {
          this.refreshEvent.target.complete();
        }
      });
  }

  cancelDoctorAppointment() {
    console.log('bookingId = ', this.bookingId);
    let curTime = new Date().toString().split(' ')[4];
    let requestdata = JSON.stringify({
      bookingId: this.bookingId,
      patientId: localStorage.getItem('patient_id'),
      cancel_time: curTime,
    });
    this.services.postRequest('cancelDoctorAppointment', requestdata).subscribe(
      (response) => {
        console.log('Doctors List => ', response);
        if (response.status == 1) {
          this.pageNo = 1;
          if (response.data.details[0].msgcode == 1) {
            this.Alertpopup(this.addCall.title502, response.status);
          } else if (response.data.details[0].msgcode == 2) {
            this.Alertpopup(this.addCall.title450, response.status);
          } else if (response.data.details[0].msgcode == 3) {
            this.Alertpopup(this.addCall.title451, response.status);
          }
          this.patientBookedAppointmentList();
        } else {
          this.Alertpopup(this.addCall.title503, response.status);
        }
      },
      (err) => {
        alert(err);
      }
    );
  }

  async Alertpopup(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
    });
    await alert.present();
  }

  async Alertpopup_VC(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert_vc',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
    });
    await alert.present();
  }

  getReview() {
    console.log('str Rating=>', this.getStrRating);
    let apiData = JSON.stringify({
      doctorId: this.getDocId,
      patientId: localStorage.getItem('patient_id'),
      value: this.getStrRating,
      remarks: this.getRemark,
    });
    this.services
      .postRequest('updateDoctorReview', apiData)
      .subscribe((res) => {
        console.log(res);
        if (res.status == 1) {
          this.presentToast(res.msg);
          this.reviewPopUp = false;
          this.getRemark = null;
        }
      });
  }

  async getReview12() {
    console.log('str Rating=>', this.getStrRating);
    let apiData = JSON.stringify({
      doctorId: this.getDocId,
      patientId: localStorage.getItem('patient_id'),
      value: this.getStrRating,
      remarks: this.getRemark,
    });

    this.services
      .postRequest('updateDoctorReview', apiData)
      .subscribe((res) => {
        console.log(res);
        if (res.status == 1) {
          // Create and display the custom popup component
          this.presentCustomPopup('Successfully reviewed', 'success');
          this.reviewPopUp = true;
          this.getRemark = null;
        }
      });
  }

  async presentCustomPopup(msg: string, status: string) {
    const modal = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert', // Your custom component
      componentProps: {
        msg: msg,
        status: status,
      },
    });
    return await modal.present();
  }

  async getVdoConf(data) {
    // ------------------------------------------------

    // Continue with the existing logic from getVdoConf
    if (data.book_date < new Date().toISOString().split('T')[0]) {
      this.openVcPlaybackVideo(data.meetingid);
    } else if (data.book_date == new Date().toISOString().split('T')[0]) {
      this.update_vcStatus(data.bookingId);

      // Continue with the existing logic from getVdoConf
      const start_number = data.before_from_time;
      const end_number = data.to_time;
      const starttime = data.from_time;
      const allowend = data.from_time;
      this.endtime = data.after_to_time;

      // Remaining logic from getVdoConf
      const currentTime = new Date();
      const startnumber = new Date(`1970-01-01T${start_number}Z`);
      const endnumber = new Date(`1970-01-01T${end_number}Z`);
      const startTime = new Date(`1970-01-01T${starttime}Z`);
      const allowEndTime = new Date(`1970-01-01T${allowend}Z`);

      // Rest of the logic from getVdoConf
      const currentTimeString = `${currentTime
        .getHours()
        .toString()
        .padStart(2, '0')}:${currentTime
          .getMinutes()
          .toString()
          .padStart(2, '0')}:${currentTime
            .getSeconds()
            .toString()
            .padStart(2, '0')}`;

      const resultDate1 = new Date(startTime.getTime() - startnumber.getTime());
      const startTimea = resultDate1.toISOString().substr(11, 8);
      const resultDate = new Date(allowEndTime.getTime() + endnumber.getTime());
      const allowEndTimea = resultDate.toString().substr(16, 8);

      console.log(
        'Current Time:',
        currentTime,
        typeof currentTime,
        currentTimeString,
        typeof currentTimeString
      );
      console.log('Start Time:', startTime);
      console.log('Allow End Time:', allowEndTime);
      console.log(
        'startTimea:',
        resultDate1,
        typeof resultDate1,
        startTimea,
        typeof startTimea
      );
      console.log(
        'allowEndTimea:',
        resultDate,
        typeof resultDate,
        allowEndTimea,
        typeof allowEndTimea
      );
      console.log(
        'allowEndTimea------:',
        startTimea < currentTimeString && currentTimeString < allowEndTimea
      );
      console.log(
        'allowEndTimea------:',
        startTimea > allowEndTimea && startTimea < this.endtime
      );
      console.log('allowEndTimea------:', startTimea > this.endtime);
      console.log('allowEndTimea------:', startTimea > currentTimeString);
      console.log('currentTimeString------:', currentTimeString);
      console.log('startTimea------:', startTimea);
      console.log('allowEndTimea------:', allowEndTimea);
      console.log('this.endtime------:', this.endtime);

      // Continue with the rest of the logic from getVdoConf
      if (
        this.endtime > currentTimeString &&
        start_number <= currentTimeString
      ) {
        this.router.navigate(['/videocall'], { queryParams: { roomName: data.doc_vc_room.split("/")[3], endTime: this.endtime } });
        this.presentToast('Meeting has started. You can join the meeting.');
      } else if (startTimea > allowEndTimea && startTimea < this.endtime) {
        this.presentToast(
          'Delay for entry. Meeting is still ongoing but entry is delayed.'
        );
      } else if (this.endtime <= currentTimeString) {
        this.Alertpopup_VC(
          'Meeting has ended. You cannot join the meeting.',
          73
        );
      } else if (startTimea > currentTimeString) {
        this.presentToast('You cannot join the meeting now. Please wait.');
      } else if (start_number >= currentTimeString) {
        this.Alertpopup_VC(this.addCall.title625, 73);
      }
    }
  }

  userapprove_Status: any = 0;
  Doctorapprove_Status: any = 0;
  playVid: any;
  id: any = 'vdo';
  Type: any;
  Path: any;
  ThumNail: any;

  async vc_permission(booking_id, memberapprove, doctorapprove) {
    console.log(memberapprove, 'memberapprove', doctorapprove, 'doctorapprove');

    if (memberapprove == 'R' || memberapprove == 'P') {
      const alert = await this.modalCtrl.create({
        component: PopupalertPage,
        cssClass: 'class_alert',
        backdropDismiss: false,
        componentProps: {
          msg: this.addCall.title434,
          sts: 6,
          frm: 'check vc permission',
        },
      });

      alert.onDidDismiss().then((data) => {
        console.log(data);
        if (data.data == 'yes') {
          this.userapprove_Status = 'A';
        } else {
          this.userapprove_Status = 'R';
        }

        let apiData = JSON.stringify({
          bookingId: booking_id,
          approvalStatus: this.userapprove_Status,
          type: 'Member',
        });
        this.services
          .postRequest('updateVCApprovalStatus', apiData)
          .subscribe((res) => {
            console.log(res);
            this.DocAppointmentHis = [];
            this.openHistory();
          });
      });
      await alert.present();
    }

    if (
      memberapprove == 'A' &&
      (doctorapprove == 'R' || doctorapprove == 'P')
    ) {
      this.Alertpopup(this.addCall.title452, 2);
    }

    if (memberapprove == 'A' && doctorapprove == 'A') {
      this.history = false;
      this.presentView = 'vc_video';
      this.Type = 'Video';
      this.Path =
        'http://157.241.0.129:8000//uploads/file-1655215322863Video2_Trim.mp4';
      this.ThumNail =
        'http://157.241.0.129:8000//uploads/file-1655215303239Video2_Moment.jpg';
    }
  }

  update_vcStatus(booking_id) {
    let apiData = JSON.stringify({
      bookingId: booking_id,
      approvalStatus: '1',
      type: 'MemberVC',
    });
    this.services
      .postRequest('updateVCApprovalStatus', apiData)
      .subscribe((res) => {
        console.log(res);
      });
  }

  async reviewPopup(docId, proImg, docName, reviewcount, doctorbookingid) {
    console.log(reviewcount);

    if (reviewcount == 0) {
      const alert = await this.modalCtrl.create({
        component: ReviewPage,
        cssClass: 'review-class',
        componentProps: {
          Id: docId,
          Img: proImg,
          Name: docName,
          From: 'DocRev',
          bookingId: doctorbookingid,
        },
      });
      alert.onDidDismiss().then((data) => {
        console.log(data);
        if (data.data == 'dismiss') {
          this.DocAppointmentHis = [];
          this.openHistory();
        }
      });
      await alert.present();
    }
  }
  storarrdetails: any = [];
  checkingtimevalidation() {
    this.DocAppointment.forEach((date, index) => {
      let datetime = date.sel_date.split(' ');
      console.log(new Date() < new Date(datetime[0] + 'T' + datetime[1]));
      console.log(new Date(datetime[0] + 'T' + datetime[1]));
      if (
        date.appointmentTypeId == 2 &&
        new Date() < new Date(datetime[0] + 'T' + datetime[1])
      ) {
        this.showtimer(datetime[0], datetime[1], index);
        console.log(index);
      }
    });
  }

  showtimer(date, time, i) {
    this.time = setInterval(() => {

      let difference = this.common.getTimeDiffernce1(time, date);

      if (difference >= -300000 && difference <= 0) {
        console.log('checkvalidaion');

        var duration = Math.floor(
          Math.abs(
            (new Date().getTime() - new Date(date + 'T' + time).getTime()) /
            1000
          )
        );
        var obj = this;

        var timer = duration,
          minutes,
          seconds;

        minutes = parseInt(String(timer / 60), 10);
        seconds = parseInt(String(timer % 60), 10);

        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        if (i != '' && document.getElementById('vc_' + i) != null) {
          document.getElementById('vc_' + i).innerHTML =
            minutes + ':' + seconds;
        }
      } else {
        clearInterval(this.time);
        if (i != '' && document.getElementById('vc_' + i) != null) {
          document.getElementById('vc_' + i).innerHTML = '';
        }
      }
    }, 1000);
  }

  openmap(clinicname, clinic_address, clinic_lat_long) {
    console.log(clinicname, 'clinicname', clinic_address, 'clinic address');

    this.clinicname = clinicname;
    console.log('map function');
    this.presentView = 'maptab';
    this.appointment = false;

    console.log(this.latitude, this.longitude);
    let latLng = new google.maps.LatLng(this.latitude, this.longitude);
    let mapOptions = {
      center: latLng,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      map: this.map,
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.directionsDisplay.setMap(this.map);
    this.calculateAndDisplayRoute(clinic_address, clinic_lat_long);
  }

  address: any;
  getReverseGeocodingData(latitude, longitude) {
    let latlng = new google.maps.LatLng(latitude, longitude);
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ latLng: latlng }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        console.log(status);
      }
      if (status == google.maps.GeocoderStatus.OK) {
        console.log(results);
        console.log(status);
        let address = results[0].formatted_address;
        this.address = address;
        let country = results[results.length - 1].formatted_address;
        console.log(address);
        console.log(country);
        console.log(results[0].address_components);
      }
    });
  }

  ClinicAddress: any;
  calculateAndDisplayRoute(clinic_address, clinic_lat_long) {
    this.ClinicAddress = clinic_address;
    const that = this;
    this.directionsService.route(
      {
        origin: this.currentLocation,
        destination: clinic_lat_long,
        travelMode: 'DRIVING',
      },
      (response, status) => {
        console.log(status, 'check direction ');

        if (status === 'OK') {
          that.directionsDisplay.setOptions({ suppressMarkers: true });
          that.directionsDisplay.setDirections(response);
          let leg = response.routes[0].legs[0];
          new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: leg.start_location,
          });
          new google.maps.Marker({
            map: this.map,
            animation: google.maps.Animation.DROP,
            position: leg.end_location,
          });
        } else {
          window.alert('Directions request failed due to ' + status);
        }
      }
    );
  }


  goToMap() {
    console.log('go to map');

    if (this.platform.is('android')) {
      var map_type = this.launchNavigator.APP.GOOGLE_MAPS;
    } else {
      map_type = this.launchNavigator.APP.APPLE_MAPS;
    }

    let options: LaunchNavigatorOptions = {
      app: map_type,
      start: [this.latitude, this.longitude],
    };
    this.launchNavigator.navigate(this.ClinicAddress, options).then(
      (success) => {
        console.log(success);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  referraldetails = [];
  viewreferral = [];
  openreferral() {
    debugger;
    this.showSlides1 = null;
    this.moduleimagesheader = 'doctorbooking';
    this.selectedCardSegment = 2;
    if (this.moduleType == 'Physio') {
      this.history = false;
      this.bookings = false;
      this.referrals = true;
      this.presentView = 'Referral';
      this.checkout('Referral');
    } else if (this.moduleType != 'Doc') {
      console.log('===>', this.bookings);

      this.history = false;
      this.bookings = false;
      this.referrals = true;
      this.presentView = 'Referral';
      this.checkout('Referral');
    } else {
      this.previousSegment = this.selectedSegment;
      this.selectedSegment = 'reff';
      this.history = false;
      this.bookings = false;
      this.referrals = true;
      console.log(localStorage.getItem('patientName'));
      this.P_Name = localStorage.getItem('patientName');
      console.log('open refferal page');
      this.presentView = 'Referral';
      this.prescrpition = false;
      this.appointment = false;

      let apiDate = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
      });

      this.services
        .postRequest('Referralpagelist', apiDate)
        .subscribe((res) => {
          console.log(res);
          if (res.status == 0) {
            this.referraldetails = [];
          } else {
            this.referraldetails = res.data.details;
          }
        });
    }
  }

  viewReferral(i) {
    this.viewreferral = this.referraldetails[i];
    this.presentView = 'viewReferral';
    this.moduleimagesheader = '';
  }

  Docpro(
    patientName,
    Docid,
    clinicid,
    splname,
    splid,
    Docname,
    referal_id,
    patientID
  ) {
    localStorage.setItem('fromPage', 'referral');
    console.log(
      'doc profile',
      patientName,
      Docid,
      clinicid,
      splname,
      splid,
      Docname,
      referal_id,
      patientID
    );
    this.router.navigate([
      '/tabs/doc-appointment',
      {
        doctorId: Docid,
        clinicId: clinicid,
        searchDate: new Date().toISOString().split('T')[0],
        serviceTypeId: '',
        splid: splid,
        Gender: '',
        splname: splname,
        docname: Docname,
        frm: 'referral',
        doc_referalId: referal_id,
        patientName: patientName,
        selectdMemId: patientID,
      },
    ]);
  }

  appionmentdetails: any;
  viewbooking(appionmentdetails, toshow) {
    this.reShedule = true;
    this.appointment = false;
    this.history = false;
    this.bookings = false;
    this.moduleimagesheader = '';
    if (toshow == 1) {
      this.presentView = 'viewbooking';
    } else {
      this.presentView = 'viewhisbooking';
    }
    console.log('view booking', appionmentdetails);
    this.appionmentdetails = appionmentdetails;
  }

  openVcPlaybackVideo(vcroomId: any) {
    //
    // Configure the AWS SDK with your credentials
    AWS.config.update({
      accessKeyId: 'AKIASZ5BWNCCSLZVB6FU',
      secretAccessKey: 'iSdequM4my6MUFBbyBWFeKx1bNDS0hKvpXqZM/AM',
      region: 'me-south-1',
    });

    // Create an S3 service object
    const s3 = new AWS.S3();

    // Specify the bucket name
    const bucketName = 'jibrirecordingvc';

    // Define the parameters for listing objects in the bucket
    const params = {
      Bucket: bucketName,
      Prefix: '', // The prefix to filter objects (leave it empty to get all objects)
    };

    // Call the S3 API to list objects in the bucket
    s3.listObjectsV2(params, (err, data) => {
      if (err) {
        console.error('Error listing objects:', err);
      } else {
        //
        // Filter the objects with the .mp4 format
        const mp4Objects = data.Contents.filter((obj) =>
          obj.Key.endsWith('.mp4')
        );

        // Iterate over each MP4 file
        mp4Objects.forEach((obj) => {
          //
          const objectKey = obj.Key;

          var result = objectKey.search(vcroomId);
          if (result != -1) {
            var path = `https://${bucketName}.s3.me-south-1.amazonaws.com/${objectKey}`;
            this.openNdPlay('video', path, 'play', '');
          }
        });
      }
    });
  }

  async openNdPlay(type, path, mode, thumnail) {
    //
    let popover = await this.modalCtrl.create({
      component: MediapopupPage,
      componentProps: {
        Type: type,
        Path: path,
        ThumNail: thumnail,
      },
      cssClass: 'media-popup',
    });
    return await popover.present();
  }

  goLabPage() {
    // Use the parameters as needed

    // Perform your navigation and localStorage operations

    localStorage.setItem('NopayGoBack', 'newEnter');

    this.router.navigate(['/tabs/lab', { twestRR: 'bookingList' }]);
  }

  checkoutmodule(typeid: number) {

    this.selectedCardindex = typeid;
    switch (typeid) {
      case 1:
        this.moduleType = 'Doc';
        this.patientBookedAppointmentList();
        this.isShowrepeatPage = false;
        break;
      case 2:
        this.moduleType = 'Lab';
        this.showTypeofBooking = '';
        this.isShowrepeatPage = false;
        break;
      case 3:
        this.moduleType = 'pharmacy';
        this.showTypeofBooking = 'booking history';
        this.isShowrepeatPage = false;
        break;
      case 4:
        console.log('bookaroom');
        this.moduleType = 'bookaroom';
        this.showTypeofBooking = '';
        this.isShowrepeatPage = false;
        this.backToAppointment();
        break;
      case 5:
        console.log('nurse');
        this.moduleType = 'nurse';
        this.showTypeofBooking = '';
        this.isShowrepeatPage = false;
        break;
      case 6:
        this.moduleType = 'diet';
        this.showTypeofBooking = '';
        this.isShowrepeatPage = false;
        break;
      case 7:
        this.moduleType = 'trainer';
        this.showTypeofBooking = '';
        this.trainer = true;
        this.isShowrepeatPage = false;
        break;
      case 8:
        this.moduleType = 'Physio';
        this.isShowrepeatPage = false;
        break;
      case 9:
        this.moduleType = 'sports';
        this.showTypeofBooking = '';
        this.isShowrepeatPage = false;
        break;
      default:
        console.log('Invalid typeid');
        break;
    }
    if (typeid == 3) {
      this.selectedCardSegment = 3;
      this.openHistory();
    } else {
      this.selectedCardSegment = 1;
      this.backToAppointment();
    }
    this.changecount = 0;
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    console.log('tariner ====', typeid);
  }

  checkout(status: string) {
    console.log('log from segment');
    this.changecount += 1;
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.showTypeofBooking = status;
    this.moduleType = this.moduleType;
  }
  changeheader: any = 'dochead';



  changeEvent(event: any) {
    console.log(event);
    debugger;
    if (event == 'profile') {
      this.changeheader = 'prfile';
    } else if (event == 'isLabBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'Lab';
    } else if (event == 'isRoomBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'bookaroom';
    } else if (event == 'isTrainerBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'trainer';
    } else if (event == 'isSportsBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'sports';
    } else if (event == 'isPhysioBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'Physio';
    } else if (event == 'isPharamaBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'pharmacy';
    } else if (event == 'isNurseBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'nurse';
    } else {
      this.changeheader = 'dochead';
    }

    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.showTypeofBooking = status;
    this.moduleType = this.moduleType;
  }

  ChangeEventTrainer(event: any) {
    debugger;
    if (event == 'profile') {
      this.changeheader = 'prfile';
    } else if (event == 'isTrainerBackHistory') {
      this.changeheader = 'dochead';
      this.moduleType = 'trainer';
      this.showTypeofBooking = 'booking hitory';
    } else if (event == 'isTrainerBackBooking') {
      this.changeheader = 'dochead';
      this.moduleType = 'trainer';
      this.showTypeofBooking = 'booking';
    } else if (event == 'isTrainerBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'trainer';
    }
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.moduleType = this.moduleType;
  }

  ChangeEventDiet(event: any) {
    debugger;
    if (event == 'profile') {
      this.changeheader = 'prfile';
    } else if (event == 'isDietBackHistory') {
      this.changeheader = 'dochead';
      this.moduleType = 'diet';
    }
  }

  ChangeEventSports(event: any) {
    debugger;
    if (event == 'profile') {
      this.changeheader = 'prfile';
    } else if (event == 'isTrainerBackHistory') {
      this.changeheader = 'dochead';
      this.moduleType = 'sports';
      this.showTypeofBooking = 'booking hitory';
    } else if (event == 'isTrainerBackBooking') {
      this.changeheader = 'dochead';
      this.moduleType = 'sports';
      this.showTypeofBooking = 'booking';
    } else if (event == 'isSportsBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'sports';
    }
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.moduleType = this.moduleType;
  }

  ChangeEventPhysio(event: any) {
    debugger;
    if (event == 'profile') {
      this.changeheader = 'prfile';
    } else if (event == 'isTrainerBackHistory') {
      this.changeheader = 'dochead';
      this.moduleType = 'Physio';
      this.showTypeofBooking = 'booking hitory';
    } else if (event == 'isTrainerBackBooking') {
      this.changeheader = 'dochead';
      this.moduleType = 'Physio';
      this.showTypeofBooking = 'booking';
    } else if (event == 'isPhysioBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'Physio';
    }
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.moduleType = this.moduleType;
  }

  ChangeEventPharma(event: any) {
    debugger;
    if (event == 'profile') {
      this.changeheader = 'prfile';
    } else if (event == 'isTrainerBackHistory') {
      this.changeheader = 'dochead';
      this.moduleType = 'pharmacy';
      this.showTypeofBooking = 'booking hitory';
    } else if (event == 'isTrainerBackBooking') {
      this.changeheader = 'dochead';
      this.moduleType = 'pharmacy';
      this.showTypeofBooking = 'booking';
    } else if (event == 'isPharamaBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'pharmacy';
    }
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.moduleType = this.moduleType;
  }
  ChangeEventNurse(event: any) {
    debugger;
    if (event == 'profile') {
      this.changeheader = 'prfile';
    } else if (event == 'isNurseBackHistory') {
      this.changeheader = 'dochead';
      this.moduleType = 'nurse';
      this.showTypeofBooking = 'booking hitory';
    } else if (event == 'isNurseBackBooking') {
      this.changeheader = 'dochead';
      this.moduleType = 'nurse';
      this.showTypeofBooking = 'booking';
    } else if (event == 'isNurseBack') {
      this.changeheader = 'dochead';
      this.moduleType = 'nurse';
    } else if (event == 'isNurseBackRepeatToHistory') {
      this.changeheader = 'dochead';
      this.moduleType = 'nurse';
      this.showTypeofBooking = 'booking hitory';
      this.isShowrepeatPage = false;
    } else if (event == 'particularBookingDetails') {
      this.showTypeofBooking = 'viewbooking';
      this.isShowrepeatPage = false;
      this.moduleType = 'nurse';
    }
    this.DocAppointment = [];
    this.DocAppointmentHis = [];
    this.moduleType = this.moduleType;
  }
  isShowrepeatPage: Boolean = false;
  nurseBookingId: any;
  patientId: any;
  nurseId: any;

  nurserepeatpagedata(event: any) {
    this.isShowrepeatPage = true;
    this.nurseBookingId = event.nurseBookingId;
    this.patientId = event.patientId;
    this.nurseId = event.nurseId;
  }
  nurseDudtyUpdate(event: any) {
    debugger;
    this.patientId = event.patientId;
    this.isShowrepeatPage = false;
  }

  checkMediaPermissions(): void {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA)
      .then(cameraPermission => {
        if (cameraPermission.hasPermission) {
          console.log('Camera permission granted');
          this.checkMicrophonePermission();
        } else {
          this.requestCameraPermission();
        }
      })
      .catch(err => console.error('Error checking camera permission:', err));
  }

  checkMicrophonePermission(): void {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.RECORD_AUDIO)
      .then(microphonePermission => {
        if (microphonePermission.hasPermission) {
          console.log('Microphone permission granted');
          this.checkStoragePermission();
        } else {
          this.requestMicrophonePermission();
        }
      })
      .catch(err => console.error('Error checking microphone permission:', err));
  }

  checkStoragePermission(): void {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
      .then(storagePermission => {
        if (storagePermission.hasPermission) {
          console.log('Storage permission granted');
          // All media permissions are granted, proceed with your logic
        } else {
          this.requestStoragePermission();
        }
      })
      .catch(err => console.error('Error checking storage permission:', err));
  }

  requestCameraPermission(): void {
    this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA)
      .then(result => {
        if (result.hasPermission) {
          console.log('Camera permission granted');
          this.checkMicrophonePermission();
        } else {
          console.log('Camera permission denied');
        }
      })
      .catch(err => console.error('Error requesting camera permission:', err));
  }

  requestMicrophonePermission(): void {
    this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.RECORD_AUDIO)
      .then(result => {
        if (result.hasPermission) {
          console.log('Microphone permission granted');
          this.checkStoragePermission();
        } else {
          console.log('Microphone permission denied');
        }
      })
      .catch(err => console.error('Error requesting microphone permission:', err));
  }

  requestStoragePermission(): void {
    this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
      .then(result => {
        if (result.hasPermission) {
          console.log('Storage permission granted');
          // All media permissions are granted, proceed with your logic
        } else {
          console.log('Storage permission denied');
        }
      })
      .catch(err => console.error('Error requesting storage permission:', err));
  }
  async OpenMapMethod(clinicname: any, clinic_address: any, clinic_lat_long: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: clinicname,
        clinic_address: clinic_address,
        clinic_lat_long: clinic_lat_long,
      }
    });
    modal.onDidDismiss()
    // .then((data) => {
    //   if (data.data == "Map_Not_Show") {
    //      this.ionViewWillEnter();
    //   }
    // });
    return await modal.present();
  }


  getbookingdetails() {
    debugger;

    const typeId = this.routeTypeId

    let endpoint = "";
    if (typeId === "1" || typeId === "3") {
      localStorage.setItem('VendorType', typeId);
      endpoint = "walkinPatientAppointmentDetails?bookingId=";
    } else {
      localStorage.setItem('VendorType', typeId);
      endpoint = "walkinPhysioPatientAppointmentDetails?bookingId=";
    }
    let requestdata = {
      "bookingId": this.routeId
    };
    this.docListReq = this.services
      .postRequestdocs(endpoint + this.routeId)
      .subscribe((response) => {
        debugger;
        console.log('Doctors List => ', response);
        this.FilterDocList = response.data;
        this.appionmentdetails = response.data[0];
        this.presentView = 'appointment'
      });
  }
}
